import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import "@zenlayer/zen-design/esm/layout/style";
import _Layout from "@zenlayer/zen-design/esm/layout";
import React from 'react';
import t from '@zenlayer/zen-intl18';
import { getCompanyName } from "../../data/consoleInfo";
import { getCopyrightInfo } from "../../data/consoleInfo";
/**
 * 页脚组件，包括汇款信息和条款信息
 * @component
 */

import { jsx as _jsx } from "react/jsx-runtime";

var Footer = function Footer(props) {
  return /*#__PURE__*/_jsx(_Layout.Footer, _objectSpread({
    company: getCompanyName() || t('N6G664yFID5W'),
    links: getCopyrightInfo()
  }, props));
};

export default Footer;